var footerText = `Created by <span class="blue"><a href="https://github.com/DevDigression" target="_blank">Chris Rodgers</a><span>`;

export default footerText;



// WEBPACK FOOTER //
// ./src/components/page-components/landing-footer-data.js